import styled from 'styled-components'
import { Triangle } from '~/components/icons'

export const StyledTokenWrap = styled.div<{ withSelection: boolean }>`
  background: ${({ theme }) => theme.colors.bgCard};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(31, 38, 77, 0.054906);
  border-radius: 56px;
  display: inline-flex;
  height: 56px;
  max-width: 165px;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: ${({ withSelection }) => (withSelection ? '12px' : '20px')};
  cursor: pointer;

  @media screen and (max-width: 640px) {
    padding-left: 6px;
    padding-right: ${({ withSelection }) => (withSelection ? '12px' : '20px')};
    justify-content: flex-start;
  }
`

export const StyledTokenWrapLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

export const StyledTokenSymbol = styled.div`
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textStrong};
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 7px;
`

export const StyledTriangle = styled(Triangle)`
  margin-left: 7px;
`
